﻿import {ResidencyId} from "../../nominalTypes/ResidencyId";
import {CreateResidencyArguments} from "../../types/arguments/CreateResidencyArguments";
import {UpdateEntityAttachmentArguments} from "../../types/arguments/UpdateEntityAttachmentArguments";
import IPermitsResidencies from "../IPermitsResidencies";
import {PermitsFrontClient} from "./PermitsFrontClient";

export class PermitsResidencies implements IPermitsResidencies {
	_client: PermitsFrontClient;

	constructor(client: PermitsFrontClient) {
		this._client = client;
	}

	create(data: CreateResidencyArguments, signal?: AbortSignal | undefined): Promise<ResidencyId> {
		return this._client.jsonFetch("residencies", "POST", data, {
			signal: signal
		});
	}

	public updateAttachments(residencyId: ResidencyId, data: UpdateEntityAttachmentArguments, signal?: AbortSignal | undefined): Promise<void> {
		return this._client.nullFetch(`residencies/${residencyId}/attachments`, "PUT", data, {
			signal: signal
		});
	}
}
